import merge from 'lodash/merge';
import BackboneElement from '@/fhirworks/BackboneElement';
import Reference from '@/fhirworks/types/Reference';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';

export default class DocumentReferenceAttester extends BackboneElement {
    static __className = 'DocumentReferenceAttester';

    __objectStructure = {
        mode: CodeableConcept,
        time: String,
        party: Reference,
    };

    constructor(constructJson, className = 'DocumentReferenceAttester') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }
    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
